import React from 'react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-labelledby="testimonials-heading" className="w-full bg-white text-ink" data-id="element-269" data-mp="3kpuirmacsxk5">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-270" data-mp="3fze09nroelqx">
        <div className="text-center" data-id="element-271" data-mp="3fxkusbssu7ki">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-272" data-mp="3b146nhllnt7f">
            Coach to coach
          </p>
          <h2 id="testimonials-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-273" data-mp="36zqyv1yy5fxv">
            What coaches are saying
          </h2>
        </div>

        <div className="mt-10 gap-4 sm:columns-2 lg:columns-3" data-id="element-274" data-mp="2x11sa5ci3hwx">
          {testimonials.map(item => <figure key={item.author} className="mb-4 break-inside-avoid rounded-2xl border border-ice-dark bg-white p-6 shadow-card" data-id="element-275" data-mp="2s3tai5v9lfw7">
              <h3 className="font-display text-xl font-bold uppercase leading-tight text-ink" data-id="element-276" data-mp="qavbfsaw9r2t">
                “{item.headline}”
              </h3>
              <blockquote className="mt-3 space-y-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-277" data-mp="m4rmy9btd84u">
                {item.quote.map(paragraph => <p key={paragraph} data-id="element-278" data-mp="79bntpwdmm1l">{paragraph}</p>)}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-ice-dark pt-4" data-id="element-279" data-mp="c7n0e8e23ani">
                {item.avatar ? <img src={item.avatar} alt="" width={40} height={40} loading="lazy" className="h-10 w-10 flex-none rounded-full object-cover" data-id="element-280" data-mp="zyscqdksfkt2" /> : <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white" data-id="element-281" data-mp="1ivacni9sir0e">
                    {initials(item.author)}
                  </span>}
                <span className="min-w-0 text-xs text-ink-muted" data-id="element-282" data-mp="1sj5y9qkufb63">
                  <span className="block text-sm font-bold text-ink" data-id="element-283" data-mp="1sgtdl5npampc">
                    {item.author}{' '}
                    <span className="font-normal text-ink-muted" data-id="element-284" data-mp="1oj5j23px6vxz">· {item.location}</span>
                  </span>
                  {item.role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(/\s+/).map(part => part.replace(/[^A-Za-z]/g, '').charAt(0)).join('').slice(0, 2).toUpperCase();
}